var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBellNotificationManage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19.329,
    height: 20.645,
    viewBox: "0 0 19.329 20.645",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_604",
    "data-name": "Ret\\xE2ngulo 604",
    width: 19.329,
    height: 20.645
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1530",
    "data-name": "Grupo 1530",
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1530-2",
    "data-name": "Grupo 1530",
    transform: "translate(0 0.001)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_800",
    "data-name": "Caminho 800",
    d: "M20.443,16.995v-2.16l-1.71-.36c-.09-.18-.18-.45-.27-.63l.99-1.44-1.53-1.53-1.44.99c-.18-.09-.45-.18-.63-.27l-.36-1.71h-2.16l-.27,1.71c-.269.09-.45.18-.719.27l-1.351-.99c-.54.54-1.08.99-1.53,1.53l.99,1.44a2.244,2.244,0,0,0-.36.63l-1.62.36v2.16l1.62.27a2.683,2.683,0,0,0,.36.72l-.99,1.44c.451.45.99.99,1.53,1.44l1.351-.99a2.679,2.679,0,0,0,.719.36l.27,1.71h2.16l.36-1.71a2.244,2.244,0,0,0,.63-.36l1.44.99c.54-.45.99-.99,1.53-1.44l-.99-1.44c.09-.27.18-.45.27-.72Zm-6.03,1.17a2.25,2.25,0,1,1,0-4.5,2.25,2.25,0,1,1,0,4.5",
    transform: "translate(-1.114 -1.3)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_801",
    "data-name": "Caminho 801",
    d: "M5.723,13.232,7.8,12.771a2.893,2.893,0,0,1,.461-.807L6.991,10.119c.577-.691,1.268-1.268,1.96-1.96L10.68,9.428c.346-.116.577-.231.922-.347l.09-.575V7.1A5.09,5.09,0,0,0,7.935,1.821V1.253a1.253,1.253,0,1,0-2.506,0v.568c-2.4.568-3.758,2.706-3.758,5.279v4.176L0,12.946v.836H5.723Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_802",
    "data-name": "Caminho 802",
    d: "M6.481,16.828H5.77a1.668,1.668,0,0,0,.711,1.364Z",
    transform: "translate(-0.759 -2.213)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_803",
    "data-name": "Caminho 803",
    d: "M6.626,18.427a1.662,1.662,0,0,0,.927.281,1.687,1.687,0,0,0,.411-.058Z",
    transform: "translate(-0.871 -2.423)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBellNotificationManage);
export default __webpack_public_path__ + "static/media/iconBellNotificationManage.df872fd757f04906da389d37241cbca6.svg";
export { ForwardRef as ReactComponent };